import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";
import { Observable } from "rxjs";
import { config } from "@config/config";

@Injectable({
  providedIn: "root",
})
export class MasterNetService {
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {}
  
  /**
   * MYTA MADERUELO IMPLEMENTATION
   */
  configUrl =
    this.appConfigService.getConfig().masterNetURL + "/masternet/api";

   acceptedPrevision(TKNUM: string, TDLNR:string): Observable<any> {
    const query = {
      filter: {
            TKNUM,
            TDLNR,
            acceptedStatus: 0
            }
          };

    // tslint:disable-next-line:max-line-length
    return this.http.post(`${this.configUrl}/previsions/list`, query, {headers: new HttpHeaders().set("Content-Type", "application/json")});
  }
  /**
   * MYTA MADERUELO IMPLEMENTATION
   */
  updatePrevisionDate(prevision: any): Observable<any> {
      return this.http.post(`${this.configUrl}/previsions/updateDate`, prevision, {headers: new HttpHeaders().set("Content-Type", "application/json")});
  }
}